module.exports = __webpack_public_path__ + "media/deal.a91309a7.wav";